<template>
  <div :class="right == true ? 'right_nav' : 'right_nav2'">
    <div class="right_nav_top"></div>
    <div class="right_nav_center">
      <a
        @mouseenter="publicNumber"
        class="bg1 right_ewm"
        href="javascript:;"
        style="margin-top:0;"
      >公众号
        <i v-show="publicNum"></i>
      </a>
      <a @click="pushOld('tourism/travel_cards.jsp')" class="bg2" href="javascript:void(0);">旅游卡查询
        <i></i>
      </a>
      <a @mouseenter="phoneWebFlag" class="bg3 sj_ewm" href="javascript:;">手机网站
        <i></i>
      </a>
      <div class="sj_box" v-show="phoneWeb">
        <img alt src="~@/assets/images/html/sjewm.png">
        <i @click="phoneWebFlagClose" class="close">x</i>
      </div>
      <a @click="goTop" class="bg4 backTop" href="javascript:;">TOP</a>
      <div class="right_box" v-show="publicNum">
        <div class="right-img" v-html="html_right"></div>
        <i @click="publicNumberClose" class="close">x</i>
      </div>
    </div>
    <div class="right_nav_bottom"></div>
  </div>
</template>
<script>
export default {
  name: "RightNavigation",
  componentName: "RightNavigation",
  data () {
    return {
      right_nav_url: 'webpart/images_pc/qr_img',
      html_right: '',
      right: true,
      phoneWeb: false,
      publicNum: true,
    }
  },
  created () {
    this.$myGet(this.right_nav_url)
      .then(res => {
        this.html_right = res.response.data.imgUrls;
      })
      .catch(err => {
        this.$msg('[' + err.status + ']' + err.message);
      })
  },
  methods: {
    pushOld (url) {
      window.location.href = this.$getOldWebUrl() + url
    },
    phoneWebFlag () {
      this.phoneWeb = true
    },
    publicNumber () {
      this.publicNum = true
    },
    phoneWebFlagClose () {
      this.phoneWeb = false
    },
    publicNumberClose () {
      this.publicNum = false
    },
    goTop () {
      document.documentElement.scrollTop = 0
    },
    handleScroll () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 400) {
        this.right = false
      } else {
        this.right = true
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
}
</script>
<style scoped>
@import '../../assets/css/pages/html/rightNav.css';
</style>



// WEBPACK FOOTER //
// src/pages/components/rightNavigation.vue